import type { locales } from '~/src/i18n/getTranslations.ts'

export const COOKIE_CATEGORIES = [
  'necessary',
  'marketing',
  'analytics',
  'uncategorized',
  'security',
  'personalization',
] as const

export type CookieCategory = (typeof COOKIE_CATEGORIES)[number]

export type CookieRecord = {
  id: string
  category: CookieCategory
  cookie: string
  domain: string
  description: string
  retentionPeriod: string
  dataController: string
  privacyLink: string
  wildcardMatch: `${number}`
}

export type Locale = (typeof locales)[number]

export type CookieTranslations = Record<string, Array<CookieRecord>>
